module.exports = __webpack_public_path__ + "static/screenshot-ad45ce9be8ab72820c778a1612c0ab64.png";